import { MessageCircle, Printer, X } from "lucide-react";
import { useSignature } from "@/components/SignatureModal";
import { buildReceiptText, sendWhatsApp } from "@/lib/whatsapp";

const money = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
const fmtDate = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("pt-BR");

export const ReceiptModal = ({ entry, onClose }) => {
  const [sig] = useSignature(entry.church);
  const total = entry.pix + entry.cartao + entry.dinheiro;
  const methods = [["Pix", entry.pix], ["Cartão", entry.cartao], ["Dinheiro", entry.dinheiro]].filter(([, v]) => v > 0);
  return <div className="modal-backdrop receipt-backdrop"><div className="modal receipt-modal">
    <div className="receipt-toolbar no-print">
      <button data-testid="receipt-print-button" className="primary-btn compact" onClick={() => window.print()}><Printer size={16} /> Imprimir recibo</button>
      <button data-testid="receipt-whatsapp-button" className="whatsapp-btn compact" onClick={() => sendWhatsApp({ phone: entry.tither_phone, text: buildReceiptText(entry) })}><MessageCircle size={16} /> Enviar no WhatsApp</button>
      <button data-testid="receipt-close-button" className="icon-btn" onClick={onClose}><X /></button>
    </div>
    <article className="receipt" data-testid="receipt-content">
      <header className="receipt-head">
        <img src="/logo-adsa-dark.png" alt="ADSA Brasil" />
        <div><strong>ADSA BRASIL</strong><span>Campo de Parelheiros · {entry.church}</span></div>
        <div className="receipt-no"><span>RECIBO DE DÍZIMO</span><b>Nº {entry.id.slice(-6).toUpperCase()}</b></div>
      </header>
      <p className="receipt-amount" data-testid="receipt-amount">{money(total)}</p>
      <p className="receipt-text">Recebemos de <b data-testid="receipt-tither-name">{entry.tither_name || entry.person_name}</b> a quantia de <b>{money(total)}</b>, referente a <b>dízimo</b>, entregue em {fmtDate(entry.date)} na igreja {entry.church}.</p>
      <table className="receipt-table"><tbody>
        {methods.map(([label, v]) => <tr key={label}><td>{label}</td><td>{money(v)}</td></tr>)}
        <tr className="receipt-total"><td>Total</td><td>{money(total)}</td></tr>
      </tbody></table>
      <p className="receipt-verse">"Trazei todos os dízimos à casa do tesouro" — Malaquias 3:10</p>
      <footer className="receipt-sign"><div><span />Recebido por: {entry.person_name}</div><div className="sign-slot">{sig.url && <img data-testid="receipt-signature-image" src={sig.url} alt="Assinatura do tesoureiro" />}<span />Tesouraria{sig.treasurer_name ? ` · ${sig.treasurer_name}` : ""}</div></footer>
    </article>
  </div></div>;
};
